import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Row, Col } from 'react-flexbox-grid';
import LazyLoad from 'react-lazyload';
import { Paragraph, Button, Link, Image } from 'components';
import './TwoCompanies.scss';

import Star from 'assets/images/logos/stars.svg';

const TwoCompanies = () => (
  <StaticQuery
    query={graphql`
      query {
        Clutch: file(relativePath: { eq: "awards/logo-clutch.png" }) {
          childImageSharp {
            fixed(width: 100) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        Inc: file(relativePath: { eq: "awards/logo-Inc.png" }) {
          childImageSharp {
            fixed(width: 51) {
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
        Awwwards: file(relativePath: { eq: "awards/logo-awwwards.png" }) {
          childImageSharp {
            fixed(width: 100) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    `}
    render={data => (
      <Row className={'no-gap two-companies__list'}>
        <Col
          sm={12}
          md={4}
          className={
            'two-companies__item two-companies__item--backdrop two-companies__item--fountain-blue'
          }
        >
          <Link to={'https://clutch.co/profile/boldare'} id={'awards-clutch'}>
            <div className={'two-companies__item-content'}>
              <div
                className={
                  'two-companies__image-wrapper two-companies__image-wrapper--justify'
                }
              >
                <LazyLoad once offset={200} height={30}>
                  <Image
                    src={data.Clutch.childImageSharp.fixed}
                    type="fixed"
                  />
                </LazyLoad>
                <div className={'text--bold two-companies__stars'}>
                  4.8&nbsp;
                  <LazyLoad once offset={200} height={30}>
                    <Image src={Star} />
                  </LazyLoad>
                </div>
              </div>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>1st place</span>
                <br />
                Top Web Development Companies in Poland
              </Paragraph>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>3rd place</span>
                <br />
                Top Product Design Companies
              </Paragraph>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>1st place</span>
                <br />
                Top Custom Software Development Firms 2018
              </Paragraph>
            </div>
            <Button color={'transparent'}>Boldare on Clutch</Button>
          </Link>
        </Col>
        <Col
          sm={12}
          md={4}
          className={'two-companies__item two-companies__item--puerto-rico'}
        >
          <Link
            to={'https://www.awwwards.com/Boldare/'}
            id={'awards-awwwards'}
          >
            <div className={'two-companies__item-content'}>
              <div className={'two-companies__image-wrapper'}>
                <LazyLoad once offset={200} height={30}>
                  <Image
                    src={data.Awwwards.childImageSharp.fixed}
                    type="fixed"
                  />
                </LazyLoad>
              </div>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>1st place</span>
                <br />
                Web Agencies in Poland
              </Paragraph>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>24 Projects</span>
                <br />
                Jury verified
              </Paragraph>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>10 Times</span>
                <br />
                Honorable mentions
              </Paragraph>
            </div>
            <Button color={'transparent'}>Boldare on Awwwards</Button>
          </Link>
        </Col>
        <Col
          sm={12}
          md={4}
          className={'two-companies__item two-companies__item--pattens-blue'}
        >
          <Link to={'https://www.inc.com/profile/xsolve'} id={'awards-inc'}>
            <div className={'two-companies__item-content'}>
              <div className={'two-companies__image-wrapper'}>
                <LazyLoad once offset={200} height={30}>
                  <Image src={data.Inc.childImageSharp.fixed} type="fixed" />
                </LazyLoad>
              </div>
              <Paragraph additionalClass={'two-companies__description'}>
                <span className={'text--bold'}>
                  {"Europe's Fastest-Growing"} Company 2018
                </span>{' '}
                for XSolve
                <br />
                <br />
                {
                  "We proudly present the legacy of XSolve - one of Boldare's founding companies"
                }
              </Paragraph>
            </div>
            <Button color={'transparent'}>Boldare on Inc5000</Button>
          </Link>
        </Col>
      </Row>
    )}
  />
);

export default TwoCompanies;
